import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseAddressyApiService } from './base-addressy-api.service';
import { BaseAddressyItem } from '../../../interfaces/addressy/api/address/find-api.interface';
import { AddressyFindParameters } from '../../../interfaces/addressy/address/find.interface';
import { AddressyResponse } from '../../../interfaces/addressy/api/addressy-api.interface';

@Injectable({ providedIn: 'root' })
export class AddressyFindApiService extends BaseAddressyApiService {
  private baseUrl: string = '/Find/v1.10';

  getAddresses(
    parameters: AddressyFindParameters,
    country: string = 'US'
  ): Observable<AddressyResponse<BaseAddressyItem[]>> {
    return this.get(`${this.baseUrl}/json3.ws`, {
      params: {
        Text: parameters?.searchText || '',
        Container: parameters?.containerId || '',
        country
      }
    });
  }
}
